import { defineWebModule } from '@nexus/core-web';
import { de } from '../i18n/de';
import { en } from '../i18n/en';
import { manifest } from '../manifest';

// Public web API for other modules (docs/architecture/base-modules.md).
export { ObjectLink, ObjectPicker, type ObjectPickerProps, objectRefsQuery } from './object-picker';
export {
  isOpenProject,
  type ObjectProjects,
  type ProjectObjects,
  useObjectDetails,
  useObjectGeoreferenced,
  useObjectProjects,
  useProjectObjects,
} from './object-projects';
export { ProjectDialog, type ProjectDialogProps } from './project-form';
export {
  ProjectLink,
  ProjectPicker,
  type ProjectPickerProps,
  projectRefsQuery,
} from './project-picker';
/** `data` of the records in the offline sources `projects.object` and `projects.project`. */
export type { ObjectDetails, ProjectDetails } from '../types';

/** Listed in apps/web/src/modules.ts. Pages load on first visit, each module is its own bundle. */
export const webModule = defineWebModule({
  manifest,
  messages: { de, en },
  pages: [
    {
      path: '/projects/projects',
      load: () => import('./projects-page'),
      permission: 'projects.project.read',
    },
    {
      path: '/projects/projects/$id',
      load: () => import('./project-page'),
      permission: 'projects.project.read',
    },
    {
      path: '/projects/objects',
      load: () => import('./objects-page'),
      permission: 'projects.object.read',
    },
    {
      path: '/projects/objects/$id',
      load: () => import('./object-page'),
      permission: 'projects.object.read',
    },
    {
      path: '/projects/types',
      load: () => import('./types-page'),
      permission: 'projects.settings.manage',
    },
  ],
  recordSections: [
    { key: 'projects.customer-projects', load: () => import('./customer-projects-section') },
    { key: 'projects.customer-objects', load: () => import('./customer-objects-section') },
  ],
  dashboard: [{ key: 'projects.my-projects', load: () => import('./my-projects-tile') }],
  guides: [
    {
      id: 'projects.projects',
      title: 'projects.guides.projects.title',
      summary: 'projects.guides.projects.summary',
      pages: ['/projects/projects', '/projects/projects/$id'],
      content: {
        de: () => import('./guides/projects.de.md?raw'),
        en: () => import('./guides/projects.en.md?raw'),
      },
    },
    {
      id: 'projects.objects',
      title: 'projects.guides.objects.title',
      summary: 'projects.guides.objects.summary',
      pages: ['/projects/objects', '/projects/objects/$id'],
      content: {
        de: () => import('./guides/objects.de.md?raw'),
        en: () => import('./guides/objects.en.md?raw'),
      },
    },
    {
      id: 'projects.types',
      title: 'projects.guides.types.title',
      summary: 'projects.guides.types.summary',
      pages: ['/projects/types'],
      content: {
        de: () => import('./guides/types.de.md?raw'),
        en: () => import('./guides/types.en.md?raw'),
      },
    },
  ],
});
